<template>
  <div class="clipboard-compare">
    <div class="compare-table mb-48">
      <div class="compare-table__body">
        <div class="compare-table__header">
          <div class="compare-table__cell title"></div>
          <div
            class="compare-table__cell"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            <div class="compare-table__image m-auto">
              <img
                :src="getUrl(idx)"
                :alt="getOfrName(idx)"
                @error="onImageError"
                @load="hideLoader"
                width="200"
                height="160"
              />
              <span class="image-loader">
                <loading-spinner :size="24" />
              </span>
            </div>
          </div>
        </div>

        <div class="compare-table__row">
          <div class="compare-table__cell title">Kod oferty</div>
          <div
            class="compare-table__cell font-14"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            {{ getOfrCode(idx) }}
          </div>
        </div>
        <div class="compare-table__row">
          <div class="compare-table__cell title">Nazwa hotelu</div>
          <div
            class="compare-table__cell font-m"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            {{ getOfrName(idx) }}
          </div>
        </div>
        <div class="compare-table__row">
          <div class="compare-table__cell title">Standard</div>
          <div
            class="compare-table__cell"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            <template v-if="getOfrCategory(idx) === '-'">-</template>
            <template v-else>
              <T1Stars class="category-stars" :number="getOfrCategory(idx)" />
            </template>
          </div>
        </div>
        <div class="compare-table__row">
          <div class="compare-table__cell title">Państwo</div>
          <div
            class="compare-table__cell"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            {{ getOfrCountry(idx) }}
          </div>
        </div>
        <div class="compare-table__row">
          <div class="compare-table__cell title">Miejscowość</div>
          <div
            class="compare-table__cell"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            {{ getOfrCity(idx) }}
          </div>
        </div>
        <div class="compare-table__row">
          <div class="compare-table__cell title">Liczba osób</div>
          <div
            class="compare-table__cell"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            {{ getOfrPersons(idx) }}
          </div>
        </div>
        <div class="compare-table__row">
          <div class="compare-table__cell title">Dojazd</div>
          <div
            class="compare-table__cell"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            {{ getOfrTransportType(idx) }}
          </div>
        </div>
        <div class="compare-table__row">
          <div class="compare-table__cell title">Wyjazd z</div>
          <div
            class="compare-table__cell"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            {{ getOfrDeparture(idx) }}
          </div>
        </div>
        <div class="compare-table__row">
          <div class="compare-table__cell title">Termin wyjazdu</div>
          <div
            class="compare-table__cell"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            {{ getOfrDate(idx) }}
          </div>
        </div>
        <div class="compare-table__row">
          <div class="compare-table__cell title">Długość pobytu</div>
          <div
            class="compare-table__cell"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            {{ getOfrDuration(idx) }}
          </div>
        </div>
        <div class="compare-table__row">
          <div class="compare-table__cell title">Wyżywienie</div>
          <div
            class="compare-table__cell"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            {{ getOfrService(idx) }}
          </div>
        </div>
        <div class="compare-table__row">
          <div class="compare-table__cell title">Zakwaterowanie</div>
          <div
            class="compare-table__cell"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            {{ getOfrRoom(idx) }}
          </div>
        </div>
        <div class="compare-table__footer pt-18 pb-18">
          <div class="compare-table__cell title"></div>
          <div
            class="compare-table__cell"
            :style="{ width: 100 / seloferty.length + '%' }"
            v-for="(item, idx) in seloferty"
            :key="idx"
          >
            <a
              :href="getLinkUrl(idx)"
              class="btn btn-md btn-yellow"
              rel="noopener"
              target="_blank"
              >Zobacz ofertę</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="text-center">
      <a :href="getClipboardLink()" class="btn btn-lg btn-d-blue pl-32 pr-32"
        >Powrót do schowka</a
      >
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import T1VarLoader from "./T1VarLoader";
import T1Stars from "./T1Shared/T1Stars";
import { domains } from "./domains.js";
// import { frontlinki } from "./frontlinki.js";
// import * as CONFIG from "./config.js";

// axios.defaults.withCredentials = false;

var xml2js = require("xml2js");

export default {
  // props: {
  //   locid: String,
  // },
  data: () => ({
    // url: "/getoferty.json",
    // dparams: "",
    oferty: [],
    seloferty: [],
    offersReady: false,
    domeny: domains.countries,
    // items: frontlinki.items,
    ilofert: 0,
    comparison: [],
  }),
  methods: {
    getOfrCode(idx) {
      if (this.seloferty.length > 0) {
        return (
          this.getUrlDomena(this.seloferty[idx], "kod") +
          this.seloferty[idx].ofr.tourOp +
          "-" +
          this.seloferty[idx].ofr.obj.code
        );
      } else {
        return "";
      }
    },
    getOfrName(idx) {
      if (this.seloferty.length > 0) {
        return this.seloferty[idx].ofr.obj.name;
      } else {
        return "";
      }
    },
    getOfrCategory(idx) {
      if (this.seloferty.length > 0) {
        if (this.seloferty[idx].ofr.obj.category != "0") {
          return this.seloferty[idx].ofr.obj.category;
        } else {
          return "-";
        }
      } else {
        return "";
      }
    },
    getOfrCountry(idx) {
      if (this.seloferty.length > 0) {
        return this.seloferty[idx].ofr.obj.country;
      } else {
        return "";
      }
    },
    getOfrCity(idx) {
      if (this.seloferty.length > 0) {
        if (this.seloferty[idx].ofr.obj.city != "") {
          return this.seloferty[idx].ofr.obj.city;
        } else {
          return this.seloferty[idx].ofr.obj.xCity;
        }
      } else {
        return "";
      }
    },
    getOfrPersons(idx) {
      if (this.seloferty.length > 0) {
        if (this.seloferty[idx].ofr.obj.maxAdt == "1") {
          return this.seloferty[idx].ofr.obj.maxAdt + " osoba";
        } else if (
          this.seloferty[idx].ofr.obj.maxAdt == "2" ||
          this.seloferty[idx].ofr.obj.maxAdt == "3" ||
          this.seloferty[idx].ofr.obj.maxAdt == "4"
        ) {
          return this.seloferty[idx].ofr.obj.maxAdt + " osoby";
        } else {
          return this.seloferty[idx].ofr.obj.maxAdt + " osób";
        }
      } else {
        return "";
      }
    },
    getOfrTransportType(idx) {
      if (this.seloferty.length > 0) {
        if (this.seloferty[idx].ofr.type === "F") {
          return "Samolot";
        } else if (this.seloferty[idx].ofr.type === "BU") {
          return "Autokar";
        } else if (this.seloferty[idx].ofr.type === "H") {
          return "Własny";
        } else {
          return this.seloferty[idx].ofr.type;
        }
      } else {
        return "";
      }
    },
    getOfrDeparture(idx) {
      if (this.seloferty.length > 0) {
        if (this.seloferty[idx].ofr.trp.depDesc != "") {
          return this.seloferty[idx].ofr.trp.depDesc;
        } else {
          return "-";
        }
      } else {
        return "";
      }
    },
    getOfrDate(idx) {
      if (this.seloferty.length > 0) {
        return this.formatData(this.seloferty[idx].ofr.trp.startDate);
      } else {
        return "";
      }
    },
    getOfrDuration(idx) {
      if (this.seloferty.length > 0) {
        if (this.seloferty[idx].ofr.trp.durationM == "1") {
          return this.seloferty[idx].ofr.trp.durationM + " dzień";
        } else {
          return this.seloferty[idx].ofr.trp.durationM + " dni";
        }
      } else {
        return "";
      }
    },
    getOfrService(idx) {
      if (this.seloferty.length > 0) {
        return this.seloferty[idx].ofr.obj.serviceDesc;
      } else {
        return "";
      }
    },
    getOfrRoom(idx) {
      if (this.seloferty.length > 0) {
        let roomDescription = this.seloferty[idx].ofr.obj.roomDesc;
        return (
          roomDescription.charAt(0).toUpperCase() + roomDescription.slice(1)
        );
      } else {
        return "";
      }
    },
    formatData(data) {
      if (data != "" && data.length >= 8) {
        return (
          data.substring(6) +
          "." +
          data.substring(4, 6) +
          "." +
          data.substring(0, 4)
        );
      } else {
        return "";
      }
    },
    getUrlDomena(oferta, typ) {
      let ocountry = oferta.ofr.obj.country;
      if (ocountry != null && typeof ocountry === "string") {
        let lcountry = ocountry
          .replace(/\s+/g, "")
          .replace(/ą/g, "a")
          .replace(/ę/g, "e")
          .replace(/ś/g, "s")
          .replace(/ć/g, "c")
          .replace(/ń/g, "n")
          .replace(/ż/g, "z")
          .replace(/ź/g, "z")
          .replace(/ó/g, "o")
          .replace(/ł/g, "l")
          .replace(/Ą/g, "a")
          .replace(/Ę/g, "e")
          .replace(/Ś/g, "s")
          .replace(/Ć/g, "c")
          .replace(/Ń/g, "n")
          .replace(/Ż/g, "z")
          .replace(/Ź/g, "z")
          .replace(/Ó/g, "o")
          .replace(/Ł/g, "l")
          .toLowerCase();
        let elems = this.domeny.filter((e) => e.nazwa === lcountry);
        if (elems.length > 0) {
          if (typ === "domena") {
            return "https://www." + elems[0].domena;
          } else if (typ === "kod") {
            return elems[0].kod;
          } else {
            return "";
          }
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    getHref(hurl) {
      if (hurl != null && hurl != "") {
        return hurl;
      } else {
        return "/hotele/hotel.xml";
      }
    },
    getFromDate(data) {
      if (data != null && data != "" && data.length >= 8) {
        return data.substring(4, 6) + data.substring(6);
      } else {
        return "";
      }
    },
    getUrlOferta(oferta, href) {
      let lparams = this.$route.query;
      let adt = 2;
      let chd = 0;
      let inf = 0;
      let chage = "";
      if (lparams["adt"]) {
        adt = Number(lparams["adt"]);
      }
      if (lparams["chd"]) {
        chd = Number(lparams["chd"]);
      }
      if (lparams["inf"]) {
        inf = Number(lparams["inf"]);
      }
      if (lparams["chage"]) {
        chage = lparams["chage"];
      }
      //let link = 'https://www.wyspykanaryjskie.pl/merlinobiektmds-param.xml?xCode=' + oferta.ofr.obj.xCode + '&tourOp=' + oferta.ofr.tourOp + '&htlCode=' + oferta.ofr.obj.code + '&kodId=' + oferta.ofr.id;
      let link =
        (href === undefined ? this.getHref(oferta.ofr.hurl) : "") +
        "?xCode=" +
        oferta.ofr.obj.xCode +
        "&tourOp=" +
        oferta.ofr.tourOp +
        "&htlCode=" +
        oferta.ofr.obj.code +
        "&kodId=" +
        oferta.ofr.id;
      link += "&adt=" + adt;
      if (chd > 0) {
        link += "&chd=" + chd;
      }
      if (chage != "") {
        link += "&chage=" + chage;
      }
      if (inf > 0) {
        link += "&inf=" + inf;
      }
      let fromDate = this.getFromDate(oferta.ofr.trp.startDate);
      if (fromDate != "") {
        link += "&fromDate=" + fromDate;
      }
      return link;
    },
    getUrlOfertaWithDomena(oferta) {
      return this.getUrlDomena(oferta, "domena") + this.getUrlOferta(oferta);
    },
    getLinkUrl(idx) {
      if (this.seloferty.length > 0) {
        return this.getUrlOfertaWithDomena(this.seloferty[idx]);
      } else {
        return "";
      }
    },
    // getIdx() {
    //   return 0;
    // },
    // getIdex(val1, val2) {
    //   return val1;
    // },
    getClipboardLink() {
      return "/oferta/schowek.xml";
    },
    // compareValid() {
    //   if (this.comparison.length > 1) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    // getAllOferty(i) {
    //   return this.seloferty;
    // },
    // getOfertyItems(i) {
    //   return this.seloferty[i];
    // },
    // getMainRegionName() {
    //   return CONFIG.panstwo_nazwapl;
    // },
    // getLocid() {
    //   if (this.locid != null && this.locid != "") {
    //     return "&locid=" + this.locid;
    //   } else {
    //     return "";
    //   }
    // },

    getUrl(idx) {
      if (this.seloferty.length > 0) {
        let oferta = this.seloferty[idx];
        if (
          oferta.ofr !== undefined &&
          oferta.ofr.datagourl !== undefined &&
          oferta.ofr.datagourl != ""
        ) {
          return "https://" + oferta.ofr.datagourl.replace(/T320/i, "T640");
        } else {
          return (
            "https://datacf.merlinx.eu/imgbycode/T640/" +
            oferta.ofr.tourOp +
            "-" +
            oferta.ofr.obj.code +
            "-0.jpeg"
          );
        }
      } else {
        return "";
      }
    },
    hideLoader(e) {
      const loaderElem = e.target.nextElementSibling;
      loaderElem.classList.add("_hiding");

      setTimeout(() => {
        loaderElem.remove();
      }, 150);
    },
    onImageError(e) {
      e.target.src = "https://www.travelone.pl/newimgs/zaslepka_lato_zest.jpg";
    },
    processResult(result) {
	var that = this;
            if (result.Page && result.Page.ilofert) {
              var ilofert = Number(result.Page.ilofert);
              console.log("Znaleziono: " + ilofert + " ofert");
              that.ilofert = ilofert;

              if (ilofert > 0) {
                for (let i in result.Page.page["0"].offer) {
                  var current = result.Page.page["0"].offer[i];
                  var ofr = current.MDSDetails["0"].ofr["0"].$;
                  var obj = current.MDSDetails["0"].ofr["0"].obj["0"].$;
                  var trp = current.MDSDetails["0"].ofr["0"].trp["0"].$;
                  //var noffer = {};
                  const noffer = new Object();
                  noffer.ofr = ofr;
                  noffer.ofr.obj = obj;
                  noffer.ofr.trp = trp;
                  //console.log(noffer.ofr);
                  that.oferty.push(noffer);
                }
              }
              that.filterOferty();
              that.offersReady = true;
            } else {
		console.log("result.Page not found. :/");
	    } 
    },
    loadSchowekOffers() {
      var that = this;
      if (window.localStorage && (localStorage.getItem("schowek") != null)) {
        console.log("LocalStorage with Schowek offers found.");
        var result = JSON.parse(localStorage.getItem("schowek"));
        that.processResult(result);
      } else {
        T1VarLoader.loadSchowekOffers().then((data) => {
	var result = JSON.parse(localStorage.getItem("schowek"));
        that.processResult(result);
        });
      }
    },
    filterOferty() {
      var rparams = this.$route.query;
      if (rparams["kodId"]) {
        var kodIds = rparams["kodId"];
        var kodArr = kodIds.split(",");
        this.seloferty = this.oferty.filter(function (elem, index) {
          if (kodArr.includes(elem.ofr.id)) {
            return true;
          } else {
            return false;
          }
        });
        //this.$root.$emit("update:selectedOffersCount", this.seloferty.length);
      } else {
        this.seloferty = [];
      }
    },
  },
  created() {
    this.loadSchowekOffers();
  },
  components: {
    T1Stars,
  },
};
</script>

<style lang="scss" scoped>
.layout-segment {
  width: 100%;
  display: inline;
}
div.ant-row-flex:nth-child(even) {
  background: #ffffff;
  margin: 2 0 2 0;
  padding: 5 0 5 0;
}
div.ant-row-flex:nth-child(odd) {
  background: #eeeeee;
  margin: 2 0 2 0;
  padding: 5 0 5 0;
}
.clipboard-compare {
  margin-bottom: 112px;
}

.compare-table {
  $self: &;
  overflow-x: auto;
  width: 100%;

  &__body {
    margin-bottom: 24px;
    width: 100%;
  }

  &__image {
    border-radius: 2px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    overflow: hidden;
    position: relative;
    max-width: 272px;
    height: 172px;

    &::before {
      background-color: $gray-00;
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      transition: opacity linear 0.25s;
      z-index: 1;
    }

    &.__before-loaded {
      &::before {
        opacity: 1;
      }
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      align-items: flex-start;
    }

    > img {
      display: block;
      width: 100%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
      position: absolute;
      backface-visibility: hidden;
      transform: translateZ(0);
    }
  }

  &__header {
    display: table-row;
  }

  &__footer {
    border-bottom: 1px solid $border-color;
  }

  &__row {
    display: table-row;

    &:nth-of-type(odd) {
      #{ $self }__cell {
        background-color: lighten($gray-00, 1%);
      }
    }
  }

  &__cell {
    display: table-cell;
    padding: 12px;

    &:not(.title) {
      border-left: 2px solid #fff;
      min-width: 250px;
      text-align: center;
    }

    &.title {
      @include font-m;
      min-width: 182px;
    }
  }
}

.category-stars {
  color: darken($yellow-default, 5%);
  font-size: 14px;
}

.image-loader {
  background-color: $gray-00;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  transition: opacity 0.2s ease-in-out;

  &._hiding {
    opacity: 0;
  }
}
</style>
